import { EventBusTopic } from "@moodys/mdc-frontend.utils.event-bus";
import LiveHelp from "@mui/icons-material/LiveHelp";
import { ListItemIcon, ListItemText, MenuItem } from "@mui/material";

import { startLiveChat } from "components/LiveChat/liveChat.helpers";
import { styles } from "components/LiveChat/liveChat.styles";
import { useEventBus } from "hooks/useEventBus";
import { getPageLanguage, Language } from "utils/language";

const LIVE_CHAT_LABEL = {
  online: {
    [Language.ENGLISH]: "Live Chat",
    [Language.CHINESE]: "实时聊天",
    [Language.JAPANESE]: "ライブチャット",
  },
  offline: {
    [Language.ENGLISH]: "Live Chat is offline",
    [Language.CHINESE]: "实时聊天已离线",
    [Language.JAPANESE]: "ライブチャットはオフラインです",
  },
};

export const LiveChat = () => {
  const [languageNodes] = useEventBus(
    EventBusTopic.Shell.AemMenu.LanguageNodes
  );
  const [liveChat] = useEventBus(EventBusTopic.Shell.LiveChat);

  const currentLanguage = getPageLanguage(languageNodes);

  return liveChat?.isEnabled ? (
    <MenuItem
      component="button"
      css={[styles.button]}
      onClick={startLiveChat}
      disabled={!liveChat.isAvailable}
      data-testid="live-chat"
    >
      <ListItemIcon>
        <LiveHelp />
      </ListItemIcon>
      <ListItemText>
        {liveChat.isAvailable
          ? LIVE_CHAT_LABEL.online[currentLanguage]
          : LIVE_CHAT_LABEL.offline[currentLanguage]}
      </ListItemText>
    </MenuItem>
  ) : null;
};
